import React from 'react';

const StatuteContent = () => (
    <div className="space-y-8 text-gray-700 leading-relaxed text-sm md:text-base">
        <div className="text-center border-b pb-6">
            <h2 className="text-xl font-bold text-[#1B5125] uppercase tracking-wide">
                Regulamin Strony Internetowej
            </h2>
            <p className="text-gray-500 mt-2">www.fedyszyn-olszewska.pl</p>
        </div>

        <p className="font-medium text-gray-600">
            Korzystanie ze strony oznacza akceptację niniejszego Regulaminu oraz Polityki prywatności. Korzystanie ze Strony jest nieodpłatne, dobrowolne i dozwolone dla wszystkich Użytkowników.
        </p>

        <section>
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§1</span> POSTANOWIENIA OGÓLNE
            </h3>
            <p>
                Niniejszy Regulamin określa zasady korzystania ze strony internetowej prowadzonej przez <strong>Olgę Fedyszyn-Olszewską</strong> prowadzącą jednoosobową działalność gospodarczą pod nazwą <strong>KANCELARIA ADWOKACKA ADWOKAT OLGA FEDYSZYN-OLSZEWSKA</strong> z siedzibą przy Al. Tadeusza Kościuszki 93 /14 90-436 Łódź, NIP: 7262714626, REGON: 542606220.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§2</span> ZAKRES USŁUG
            </h3>
            <p className="mb-3">
                Strona ma charakter <strong>informacyjno-wizerunkowy</strong> i służy prezentacji działalności Kancelarii oraz zakresu świadczonych usług prawnych.
            </p>
            <p>
                Za pośrednictwem strony <strong>nie są zawierane umowy ani realizowane płatności</strong>. Użytkownik może skorzystać z formularza kontaktowego w celu uzyskania informacji o ofercie Kancelarii.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§3</span> ZASADY KORZYSTANIA ZE STRONY
            </h3>
            <div className="space-y-3">
                <p>Użytkownik zobowiązany jest do korzystania ze strony w sposób zgodny z prawem, zasadami współżycia społecznego oraz dobrymi obyczajami.</p>
                <p className="bg-gray-50 p-4 border-l-4 border-[#1B5125] text-sm">
                    Wszystkie treści zamieszczone na stronie mają charakter informacyjny i <strong>nie stanowią porady prawnej ani oferty handlowej</strong> w rozumieniu art. 66 Kodeksu cywilnego.
                </p>
                <p>Administrator zastrzega sobie prawo do zmiany, uaktualnienia lub usunięcia treści w dowolnym momencie bez wcześniejszego powiadomienia.</p>
            </div>
        </section>

        <section>
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§4</span> FORMULARZ KONTAKTOWY
            </h3>
            <p className="mb-3">
                W formularzu wymagane jest podanie: <strong>imię i nazwisko, adres e-mail oraz treść wiadomości/opis sprawy</strong>. Przesłanie formularza jest równoznaczne z potwierdzeniem zapoznania się z Regulaminem i Polityką prywatności.
            </p>
            <p>
                Administrator przetwarza Dane Osobowe zgodnie z obowiązującymi przepisami prawa, w szczególności z przepisami RODO.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§5</span> ODPOWIEDZIALNOŚĆ
            </h3>
            <ul className="list-disc pl-5 space-y-2">
                <li>Administrator nie odpowiada za sposób, w jaki Użytkownik korzysta ze strony.</li>
                <li>Administrator nie ponosi odpowiedzialności za przerwy techniczne w dostępności strony.</li>
                <li>Kancelaria nie odpowiada za treści zamieszczone na zewnętrznych stronach, do których prowadzą linki.</li>
            </ul>
        </section>

        <section>
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§6</span> PRAWA AUTORSKIE
            </h3>
            <p className="mb-3">
                Zawartość strony chroniona jest polskim i międzynarodowym prawem autorskim. Prawa do wszystkich materiałów zastrzeżone są na rzecz <strong>KANCELARII ADWOKACKIEJ ADWOKAT OLGA FEDYSZYN-OLSZEWSKA</strong>.
            </p>
            <p className="font-semibold text-red-900">
                Zabrania się kopiowania, rozpowszechniania lub modyfikowania treści strony bez pisemnej zgody Administratora pod rygorem odpowiedzialności prawnej.
            </p>
        </section>

        <section className="pt-4 border-t">
            <h3 className="text-lg font-bold text-[#1B5125] mb-3">
                <span className="mr-2">§7</span> POSTANOWIENIA KOŃCOWE
            </h3>
            <div className="space-y-2">
                <p>Zgłoszenia dotyczące działalności strony prosimy kierować na adres: <a href="mailto:kancelaria@fedyszyn-olszewska.pl" className="text-[#1B5125] underline font-medium">kancelaria@fedyszyn-olszewska.pl</a>.</p>
                <p>W sprawach nieuregulowanych zastosowanie mają przepisy prawa polskiego, w szczególności <strong>Kodeksu cywilnego</strong> oraz ustawy o świadczeniu usług drogą elektroniczną.</p>
            </div>
        </section>
    </div>
);

export default StatuteContent;